import React from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./spinner.module.scss";

const cx = c.bind(styles);
const rootClassName = "purpur-spinner";

export const SPINNER_SIZE = {
  XXS: "xxs",
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
} as const;

export const spinnerSizes = Object.values(SPINNER_SIZE);
export type SpinnerSize = (typeof spinnerSizes)[number];

export type SpinnerProps = Omit<BaseProps, "children"> & {
  ["data-testid"]?: string;
  disabled?: boolean;
  negative?: boolean;
  size?: SpinnerSize;
};

export const Spinner = ({
  disabled = false,
  negative = false,
  size = SPINNER_SIZE.SM,
  className,
  ...props
}: SpinnerProps) => (
  <div className={cx(rootClassName, `${rootClassName}--${size}`, className)} {...props}>
    <svg viewBox="0 0 50 50">
      <circle
        className={cx(`${rootClassName}__circle`, {
          [`${rootClassName}__circle--disabled`]: disabled,
          [`${rootClassName}__circle--negative`]: negative,
        })}
        cx="25"
        cy="25"
        r="20"
      />
    </svg>
  </div>
);

Spinner.displayName = "Spinner";
